export default {
  getLinks: (state) => state.links,
  getOrganization: (state) => state.organization,
  getOrganizations: (state) => state.organizations,
  getUser: (state) => state.user,
  getWorkspaces: (state) => state.organization.workspaces,
};
